export const ticketsSalesStyle = {
	wrapper: {
		display: 'flex',
		gap: '24px',
		marginBottom: '24px',

		'@media (max-width: 1023.98px)': {
			flexDirection: 'column',
			gap: '12px',
		},

		'@media (max-width: 639.98px)': {
			gap: '12px',
			marginBottom: '20px',
		},
	},

	title: {
		marginBottom: '16px',
	},

	date: {
		display: 'flex',
		gap: '12px',
		alignItems: 'center',
		'@media (max-width: 639.98px)': {
			flexDirection: 'column',
			alignItems: 'stretch',
		},
	},

	dateMonthYear: {
		maxWidth: '100%',
		// width: '240px',
		'@media (max-width: 639.98px)': {
			width: '100%',
		},
	},

	time: {
		'& > div:first-of-type': {maxWidth: '120px', width: '100%'},
		'@media (max-width: 639.98px)': {
			'& > div:first-of-type': {maxWidth: '100%', width: '100%'},
		},
	},
};
